<template>
  <div 
    class="fill-height">
    <v-layout wrap>
      <v-flex>
        <v-snackbar
          v-model="dialog.snackbar"
          top
          right
          color="green">
          <span 
            class="body-1 font-weight-light white--text"
            v-html="message.success">
          </span>

          <template v-slot:action="{ attrs }">
            <v-btn
              icon
              color="white"
              class="body-1 font-weight-bold text-capitalize"
              v-bind="attrs"
              @click="dialog.snackbar = false">
              <v-icon>mdi-close-circle-outline</v-icon>
            </v-btn>
          </template>
        </v-snackbar>

        <section>
          <v-row
            class="pa-4 pb-2 pr-1">
            <v-col
              cols="12">
              <v-card
                :to="`/kpi/nilai/summary/${$route.params.id}`"
                flat
                color="transparent"
                style="width: 40%;">
                <div
                  class="d-flex align-center">
                  <v-avatar
                    tile
                    size="28"
                    style="opacity: 30%;">
                    <v-img
                      contain
                      alt="humax"  
                      :src="require('@/assets/icon/back_arrow.png')">
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height"
                          align="center"
                          justify="center">
                          <v-progress-circular 
                            size="20"
                            indeterminate 
                            :color="set_color">
                          </v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                  </v-avatar>

                  <span
                    class="title black--text ml-3 one-line"
                    style="font-weight: 600;">
                    Penilaian {{ detail.name }}
                  </span>
                </div>
              </v-card>
            </v-col>
          </v-row>

          <v-row
            class="pa-4 pr-1">
            <v-col 
              cols="12"
              class="py-0">
              <v-card 
                flat
                min-height="calc(100vh - 245px)"
                style="border-radius: 10px; border: 1px solid #E7E7E7; overflow-y: auto;">
                <v-card-text>
                  <v-row>
                    <v-col
                      cols="12"
                      md="3"
                      class="py-0">
                      <v-card
                        flat
                        min-height="calc(100vh - 280px)"
                        style="border-radius: 10px; border: 2px dashed #E7E7E7;">
                        <v-card-text>
                          <div
                            class="d-flex align-center">
                            <v-avatar 
                              size="42" 
                              tile>
                              <v-img 
                                alt="humax" 
                                :src="detail.image_url !== '' ? detail.image_url : require('@/assets/image/member_default.png')"
                                class="ma-auto"
                                style="border-radius: 10px;">
                                <template v-slot:placeholder>
                                  <v-row
                                    class="fill-height"
                                    align="center"
                                    justify="center">
                                    <v-progress-circular 
                                      indeterminate 
                                      color="white">
                                    </v-progress-circular>
                                  </v-row>
                                </template>
                              </v-img>
                            </v-avatar>
                            
                            <div
                              class="black--text ml-3">
                              <div
                                class="body-1"
                                style="font-weight: 600;">
                                {{ detail.name }}
                              </div>

                              <div
                                class="body-2"
                                style="opacity: 60%;">
                                {{ detail.unit_name }}
                              </div>
                            </div>
                          </div>

                          <v-divider
                            class="my-4"
                            style="border-top: 2px dashed #E7E7E7;" />

                          <div
                            class="mb-4">
                            <div
                              class="line-text-second">
                              Periode Penilaian
                            </div>
                            
                            <div
                              class="black--text">
                              {{ detail_summary.start_date | date_month }} - {{ detail_summary.end_date | date }}
                            </div>
                          </div>

                          <div
                            class="mb-4">
                            <div
                              class="line-text-second">
                              Kategori Penilaian
                            </div>
                            
                            <div
                              class="black--text">
                              {{ detail_summary.kategori_penilaian }}
                            </div>
                          </div>

                          <div
                            class="mb-4">
                            <div
                              class="line-text-second">
                              Bobot Tugas Utama
                            </div>
                            
                            <div
                              class="black--text">
                              {{ detail_summary.nilai_tugas_utama }}
                            </div>
                          </div>

                          <div
                            class="mb-4">
                            <div
                              class="line-text-second">
                              Bobot Pengembangan Diri
                            </div>
                            
                            <div
                              class="black--text">
                              {{ detail_summary.nilai_pengembangan_diri }}
                            </div>
                          </div>

                          <div
                            class="mb-5">
                            <div
                              class="line-text-second font-weight-bold">
                              Nilai Total
                            </div>
                            
                            <div
                              class="black--text font-weight-bold">
                              {{ detail_summary.nilai_total }}
                            </div>
                          </div>

                          <v-divider
                            class="my-4"
                            style="border-top: 2px dashed #E7E7E7;" />

                          <v-list 
                            flat 
                            dense
                            color="transparent"
                            class="py-0">
                            <v-list-item 
                              v-for="(item, index) in menu"
                              :key="index"

                              @click="seelctedMenu(item.value)"

                              class="pa-0"
                              style="border-radius: 50px; background: #FFFFFF;">
                              <v-list-item-avatar 
                                tile
                                size="20"
                                class="my-2 mr-3">
                                <v-img 
                                  width="100%"
                                  height="100%"
                                  alt="humax"  
                                  :src="item.icon"
                                  class="ma-auto">
                                  <template v-slot:placeholder>
                                    <v-row
                                      class="fill-height"
                                      align="center"
                                      justify="center">
                                      <v-progress-circular 
                                        size="20"
                                        indeterminate 
                                        :color="set_color">
                                      </v-progress-circular>
                                    </v-row>
                                  </template>
                                </v-img>
                              </v-list-item-avatar>

                              <v-list-item-content>
                                <v-list-item-title
                                  class="body-2"
                                  :class="selected.menu === item.value ? '' : 'font-weight-light'"
                                  :style="selected.menu === item.value ? `font-weight: 600; color: ${set_color};` : 'font-weight: 500; opacity: 40%;'">
                                  {{ item.text }}
                                </v-list-item-title>
                              </v-list-item-content>

                              <v-list-item-action
                                class="my-2">
                                <v-icon
                                  style="position: absolute; top: 0px; bottom: 0px; right: 0px;"
                                  :size="item.size"
                                  :color="selected.menu === item.value ? item.color : ''"
                                  :style="selected.menu === item.value ? '' : 'opacity: 40%;'">
                                  {{ item.mdi }}
                                </v-icon>
                              </v-list-item-action>
                            </v-list-item>
                          </v-list>
                        </v-card-text>
                      </v-card>
                    </v-col>

                    <v-col
                      cols="12"
                      md="9"
                      :class="selected.menu < 3 ? 'pb-0' : 'py-0'">
                      <v-row v-if="selected.menu < 3"
                        justify="center">
                        <v-col
                          v-for="(item, index) in menu[selected.menu - 1].sub"
                          :key="index"
                          cols="4"
                          class="d-flex align-center justify-center pa-0">
                          <v-divider
                            :style="selected.sub >= item.value && index > 0 ? `border-bottom: 2px solid ${set_color};` : index > 0 ? 'border-bottom: 2px solid #ebebeb;' : 'border: 0px solid #FFFFFF;'" />

                          <v-btn
                            @click="goToMenu(item.value)"

                            rounded
                            elevation="0"
                            :color="selected.sub >= item.value ? set_color : '#ebebeb'"
                            class="body-2 font-weight-bold text-capitalize white--text d-flex align-center pl-2 pr-3">
                            <v-avatar
                              size="24"
                              :color="selected.sub >= item.value ? item.color : '#0000001a'">
                              <v-icon small v-if="selected.sub >= item.value">
                                {{ item.icon }}
                              </v-icon>

                              <span v-else>
                                {{ item.value }}
                              </span>
                            </v-avatar>
                            
                            <span
                              class="ml-2">
                              {{ item.text }}
                            </span>
                          </v-btn>

                          <v-divider
                            :style="selected.sub > item.value && index < menu[selected.menu - 1].sub.length - 1 ? `border-bottom: 2px solid ${set_color};` : index < menu[selected.menu - 1].sub.length - 1 ? 'border-bottom: 2px solid #ebebeb;' : 'border: 0px solid #FFFFFF;'" />
                        </v-col>
                      </v-row>
                      
                      <div v-if="Object.keys(detail).length > 0 && Object.keys(detail_summary).length > 0"
                        :class="selected.menu < 3 ? 'mt-6' : ''">
                        <ValidationObserver 
                          ref="form">
                          <v-form>
                            <!-- TUGAS UTAMA -->
                            <KP v-if="selected.menu === 1 && selected.sub === 1"
                              :detail="detail"
                              :summary="detail_summary"
                              
                              @refresh="fetchDetailSummary()" />

                            <PA v-if="selected.menu === 1 && selected.sub === 2"
                              :detail="detail"
                              :summary="detail_summary"
                              
                              @refresh="fetchDetailSummary()" />

                            <SP v-if="selected.menu === 1 && selected.sub === 3"
                              :detail="detail"
                              :summary="detail_summary"
                              
                              @refresh="fetchDetailSummary()" />

                            
                            <!-- PENGEMBANGAN DIRI -->
                            <SK v-if="selected.menu === 2 && selected.sub === 1"
                              :detail="detail"
                              :summary="detail_summary"
                              
                              @refresh="fetchDetailSummary()" />

                            <PS v-if="selected.menu === 2 && selected.sub === 2"
                              :detail="detail"
                              :summary="detail_summary"
                              
                              @refresh="fetchDetailSummary()" />
                            
                            <TD v-if="selected.menu === 2 && selected.sub === 3"
                              :detail="detail"
                              :summary="detail_summary"
                              
                              @refresh="fetchDetailSummary()" />

                            
                            <!-- SUMMARY -->
                            <SM v-if="selected.menu === 3 && selected.sub === 1"
                              :detail="detail"
                              :summary="detail_summary"
                              
                              @form="form = $event" />
                          </v-form>
                        </ValidationObserver>

                        <div v-if="message.error.length > 0"
                          class="text-center my-4 d-flex align-center">
                          <div
                            class="error--text">
                            <v-icon size="18" color="red">mdi-alert-circle-outline</v-icon>
                            
                            <span
                              class="ml-1">
                              {{ message.error }}
                            </span>
                          </div>
                        </div>
                      </div>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

          <v-row
            justify="end"
            class="pa-4 pr-1">
            <v-col
              cols="12"
              md="2"
              class="py-0">
              <v-btn v-if="selected.menu >= 1 && selected.sub >= 1"
                @click="goPrevMenu()"
                :disabled="process.form || process.print"

                block
                color="#212121"
                elevation="0"
                class="body-2 white--text text-capitalize d-flex align-center"
                style="border-radius: 10px; font-weight: 600;">
                <v-icon size="30">mdi-pan-left</v-icon>

                <span>
                  Kembali
                </span>
              </v-btn>
            </v-col>

            <v-col v-if="selected.menu > 2"
              cols="12"
              md="2"
              class="py-0">
              <v-btn
                @click="prints()"
                :loading="process.print"
                :disabled="process.print || process.form"

                block
                color="red"
                elevation="0"
                class="body-2 white--text text-capitalize d-flex align-center"
                style="border-radius: 10px;;">
                <v-icon size="20">mdi-file-pdf-box</v-icon>

                <span
                  class="ml-2">
                  Export PDF
                </span>
              </v-btn>
            </v-col>

            <v-col
              cols="12"
              md="2"
              class="py-0">
              <v-btn
                @click="selected.menu < 3 ? goNextMenu() : save()"
                :loading="process.form"
                :disabled="process.form || process.print"
                
                block
                color="#4B4B4B"
                elevation="0"
                class="body-2 white--text text-capitalize d-flex align-center"
                style="border-radius: 10px; font-weight: 600; background: linear-gradient(180deg, rgba(63, 148, 62, 1), rgba(22, 115, 20, 1));">
                <v-icon v-if="selected.menu > 2"
                  size="20">
                  mdi-checkbox-marked-circle-outline
                </v-icon>

                <span
                  :class="selected.menu > 2 ? 'ml-2' : ''">
                  {{ selected.menu < 3 ? 'Selanjutnya' : 'Simpan' }}
                </span>

                <v-icon v-if="selected.menu < 3"
                  size="30">
                  mdi-pan-right
                </v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { TokenService } from "@/service/Storage.Service";
  import { get, post, put, patch, destroy } from "@/service/Axios";
  import axios from "axios";
  import moment from "moment"
  import "moment/locale/id"
  export default {
    data () {
      return {
        dialog: {
          snackbar: false
        },

        selected: {
          menu: 1,

          sub: 1
        },
        
        menu: [
          {
            text: 'Tugas utama',
            value: 1,
            icon: require('@/assets/icon/ketepatan_pekerjaan.png'),
            mdi: 'mdi-pan-right',
            size: 30,
            color: this.$store.state.color,
            sub: [
              {
                text: 'Ketepatan Pekerjaan',
                value: 1,
                icon: 'mdi-check-bold',
                color: 'green'
              },
              {
                text: 'Penilaian Atasan',
                value: 2,
                icon: 'mdi-check-bold',
                color: 'green'
              },
              {
                text: 'Skor Presensi',
                value: 3,
                icon: 'mdi-check-bold',
                color: 'green'
              }
            ]
          },
          {
            text: 'Pengembangan Diri',
            value: 2,
            icon: require('@/assets/icon/sertifikasi_kompetensi.png'),
            mdi: 'mdi-pan-right',
            size: 30,
            color: this.$store.state.color,
            sub: [
              {
                text: 'Sertifikasi Kompetensi',
                value: 1,
                icon: 'mdi-check-bold',
                color: 'green'
              },
              {
                text: 'Pelatihan Sertifikat',
                value: 2,
                icon: 'mdi-check-bold',
                color: 'green'
              },
              {
                text: 'Terlibat Dilingkungan',
                value: 3,
                icon: 'mdi-check-bold',
                color: 'green'
              }
            ]
          },
          {
            text: 'Sumamry Skor',
            value: 3,
            icon: require('@/assets/icon/skor_presensi.png'),
            mdi: 'mdi-pan-right',
            size: 30,
            color: this.$store.state.color,
            sub: []
          }
        ],

        detail: {},
        detail_summary: {},

        form: {},

        process: {
          form: false,

          print: false
        },

        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      KP: () => import(/* webpackPrefetch: true */ '@/components/kpi/new/tugas/ketepatan_pekerjaan.vue'),
      PA: () => import(/* webpackPrefetch: true */ '@/components/kpi/new/tugas/penilaian_atasan.vue'),
      SP: () => import(/* webpackPrefetch: true */ '@/components/kpi/new/tugas/skor_presensi.vue'),

      SK: () => import(/* webpackPrefetch: true */ '@/components/kpi/new/pengembangan/sertifikasi_kompetensi.vue'),
      PS: () => import(/* webpackPrefetch: true */ '@/components/kpi/new/pengembangan/pelatihan_sertifikat.vue'),
      TD: () => import(/* webpackPrefetch: true */ '@/components/kpi/new/pengembangan/terlibat_dilingkungan.vue'),

      SM: () => import(/* webpackPrefetch: true */ '@/components/kpi/new/summary.vue')
    },
    watch: {
      
    },
    computed: {
      user () {
        return this.$store.state.user
      },
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      }
    },
    mounted () {
      this.selected.menu = this.$route.query.menu === undefined ? 1 : parseInt(this.$route.query.menu)

      this.selected.sub = this.$route.query.sub === undefined ? 1 : parseInt(this.$route.query.sub)

      this.fetch()
    },
    methods: {
      fetch () {
        this.fetchDetailUser()
        this.fetchDetailSummary()
      },

      seelctedMenu (val) {
        this.selected.menu = val

        this.selected.sub = 1

        this.$router.push({ path: `/kpi/nilai/summary/detail/${this.$route.params.id}`, query: { menu: this.selected.menu, sub: this.selected.sub, summary_id: this.$route.query.summary_id }})
      },

      goToMenu (val) {
        this.selected.sub = val

        this.$router.push({ path: `/kpi/nilai/summary/detail/${this.$route.params.id}`, query: { menu: this.selected.menu, sub: this.selected.sub, summary_id: this.$route.query.summary_id }})
      },
      
      goPrevMenu () {
        if (this.selected.menu === 3) {
          this.selected.menu = 2

          this.selected.sub = 3
        } else {
          if (this.selected.menu === 2 && this.selected.sub < 2) {
            this.selected.menu = 1

            this.selected.sub = 3
          } else {
            
            if (this.selected.menu === 1 && this.selected.sub < 2) {
              this.$router.push(`/kpi/nilai/summary/${this.$route.params.id}`)
            } else {
              this.selected.sub -= 1

              this.$router.push({ path: `/kpi/nilai/summary/detail/${this.$route.params.id}`, query: { menu: this.selected.menu, sub: this.selected.sub, summary_id: this.$route.query.summary_id }})
            }
          }
        }
      },

      goNextMenu () {
        if (this.selected.menu === 1 && this.selected.sub < 3) {
          this.selected.sub += 1
        } else {
          this.selected.sub = this.selected.menu === 1 && this.selected.sub > 2 ? 0 : this.selected.sub

          this.selected.menu = 2

          if (this.selected.menu === 2) {
            if (this.selected.sub < 3) {
              this.selected.sub += 1
            } else {
              this.selected.menu = 3

              this.selected.sub = 1
            }
          } else {
            this.selected.menu = 3

            this.selected.sub = 1
          }
        }

        this.$router.push({ path: `/kpi/nilai/summary/detail/${this.$route.params.id}`, query: { menu: this.selected.menu, sub: this.selected.sub, summary_id: this.$route.query.summary_id }})
      },

      async fetchDetailUser () {
        let params = {
          id: this.$route.params.id
        }

        await get('admin/user/detail', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.detail = res.results.data
          }
        })
      },

      async fetchDetailSummary () {
        let params = {
          id: this.$route.query.summary_id
        }

        await get('kpi_v2/score_summary/detail_summary', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.detail_summary = res.results.data

            this.menu = [
              {
                text: 'Tugas utama',
                value: 1,
                icon: require('@/assets/icon/ketepatan_pekerjaan.png'),
                mdi: Number(this.detail_summary.nilai_individu) > 0 && Number(this.detail_summary.nilai_atasan_langsung) > 0 && Number(this.detail_summary.nilai_presensi) > 0 ? 'mdi-pan-right' : 'mdi-alert-circle',
                size: Number(this.detail_summary.nilai_individu) > 0 && Number(this.detail_summary.nilai_atasan_langsung) > 0 && Number(this.detail_summary.nilai_presensi) > 0 ? 30 : 20,
                color: Number(this.detail_summary.nilai_individu) > 0 && Number(this.detail_summary.nilai_atasan_langsung) > 0 && Number(this.detail_summary.nilai_presensi) > 0 ? this.set_color : 'red',
                sub: [
                  {
                    text: 'Ketepatan Pekerjaan',
                    value: 1,
                    icon: Number(this.detail_summary.nilai_individu) > 0 ? 'mdi-check-bold' : 'mdi-exclamation-thick',
                    color: Number(this.detail_summary.nilai_individu) > 0 ? 'green' : 'red'
                  },
                  {
                    text: 'Penilaian Atasan',
                    value: 2,
                    icon: Number(this.detail_summary.nilai_atasan_langsung) > 0 ? 'mdi-check-bold' : 'mdi-exclamation-thick',
                    color: Number(this.detail_summary.nilai_atasan_langsung) > 0 ? 'green' : 'red'
                  },
                  {
                    text: 'Skor Presensi',
                    value: 3,
                    icon: Number(this.detail_summary.nilai_presensi) > 0 ? 'mdi-check-bold' : 'mdi-exclamation-thick',
                    color: Number(this.detail_summary.nilai_presensi) > 0 ? 'green' : 'red'
                  }
                ]
              },
              {
                text: 'Pengembangan Diri',
                value: 2,
                icon: require('@/assets/icon/sertifikasi_kompetensi.png'),
                mdi: Number(this.detail_summary.nilai_sertifikasi_kompetensi) > 0 && Number(this.detail_summary.nilai_pelatihan_sertifikat) > 0 && Number(this.detail_summary.nilai_keterlibatan_pegawai) > 0 ? 'mdi-pan-right' : 'mdi-alert-circle',
                size: Number(this.detail_summary.nilai_sertifikasi_kompetensi) > 0 && Number(this.detail_summary.nilai_pelatihan_sertifikat) > 0 && Number(this.detail_summary.nilai_keterlibatan_pegawai) > 0 ? 30 : 20,
                color: Number(this.detail_summary.nilai_sertifikasi_kompetensi) > 0 && Number(this.detail_summary.nilai_pelatihan_sertifikat) > 0 && Number(this.detail_summary.nilai_keterlibatan_pegawai) > 0 ? this.set_color : 'red',
                sub: [
                  {
                    text: 'Sertifikasi Kompetensi',
                    value: 1,
                    icon: Number(this.detail_summary.nilai_sertifikasi_kompetensi) > 0 ? 'mdi-check-bold' : 'mdi-exclamation-thick',
                    color: Number(this.detail_summary.nilai_sertifikasi_kompetensi) > 0 ? 'green' : 'red'
                  },
                  {
                    text: 'Pelatihan Sertifikat',
                    value: 2,
                    icon: Number(this.detail_summary.nilai_pelatihan_sertifikat) > 0 ? 'mdi-check-bold' : 'mdi-exclamation-thick',
                    color: Number(this.detail_summary.nilai_pelatihan_sertifikat) > 0 ? 'green' : 'red'
                  },
                  {
                    text: 'Terlibat Dilingkungan',
                    value: 3,
                    icon: Number(this.detail_summary.nilai_keterlibatan_pegawai) > 0 ? 'mdi-check-bold' : 'mdi-exclamation-thick',
                    color: Number(this.detail_summary.nilai_keterlibatan_pegawai) > 0 ? 'green' : 'red'
                  }
                ]
              },
              {
                text: 'Sumamry Skor',
                value: 3,
                icon: require('@/assets/icon/skor_presensi.png'),
                mdi: 'mdi-pan-right',
                size: 30,
                color: this.set_color,
                sub: []
              }
            ]
          }
        })
      },

      async save () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()

        if (isValid) {
          this.process.form = true

          // SAVE TO REST API
          await post('kpi_v2/score_summary/update_note', {
            data: this.form
          })
          .then(response => {
            let res = response.data
            
            this.process.form = false

            if (res.status === 200) {
              this.dialog.snackbar = true
              this.message.success = res.message
              
              this.$router.push(`/kpi/nilai/summary/${this.$route.params.id}`)
            } else {
              this.message.error = res.message
            }
          })

        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      },

      async prints () {
        this.message.error = ''

        this.process.print = true

        let params = {
          summary_id: this.detail_summary.id
        }

        await axios({
          url: `${process.env.VUE_APP_API_URL}kpi_v2/score_summary/print_PDF`,
          method: 'GET',
          responseType: 'blob', // important,
          params: params,
          headers: {
            Authorization: process.env.VUE_APP_XAUTH,
            token: TokenService.getToken()
          }
        }).then((response) => {
          let res = response

          this.process.print = false

          if (res.status === 200) {
            
            this.dialog.snackbar = true
            this.message.success = 'Berhasil mengeksport pdf'

            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')

            link.href = url
            link.setAttribute('download', `Amanata-${moment().format('DD-MMMM-YYYY', 'id')}-${moment().format('HH:mm:ss', 'id')}.pdf`)

            document.body.appendChild(link)

            link.click()
          } else {
            this.message.error = res.message
          }
        })
      }
    }
  }
</script>